/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Action/Delete
 * @desc Action to delete experiment workflow
 */

import { EntityActionDelete as DeleteAction } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { EntityStateWorkflowActionDeleteProps } from './types';

export const EntityStateWorkflowActionDelete: React.FC<
  EntityStateWorkflowActionDeleteProps
> = ({ entityStateWorkflow }) => (
  <DeleteAction entity={entityStateWorkflow} />
);
